import React, { useMemo } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import Crud from "../Crud";

function BlackBookList() {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  return (
    <div className="flex flex-col w-full gap-4 p-4 h-max">
      <Crud
        title="Black Book List"
        getUrl={() =>
          `/Player/Player_GetBlackBookList?idUser=${userInfo.userId}`
        }
        deleteUrl={() => ""}
        navigateUrl={({ idPlayer }) => `/player/${idPlayer}`}
      >
        <TableHeaderColumn dataSort dataField="idPlayer" isKey>
          ID
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="lineType">
          Linetype
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="profileName">
          Profile
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="status">
          Status
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="settleDate"
          dataFormat={dateTimeReportFormatter}
          width="200"
        >
          Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description" width="200">
          Reason
        </TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default BlackBookList;
